import PropTypes from "prop-types"
import React, { FC, ImgHTMLAttributes } from "react"
import { Box } from "@carrotfertility/carotene-core"

type CircleImageProps = {
  iconName: string
  backgroundColor?: string
  size?: number
  padding?: number
} & ImgHTMLAttributes<HTMLImageElement>

const TACHYONS_COLOR_MAP: Record<string, string> = {
  white: "white",
  "black-10": "rgba(0,0,0,0.1)",
  "light-gray": "#eee",
  "icon-grey": "#dae1e5",
  porcelain: "#e4e8eb"
}

/**
 * @deprecated Use a Carotene `Box` wrapping a plain `<img>` instead.
 */
const CircleImage: FC<CircleImageProps> = ({
  iconName,
  className,
  backgroundColor = "white",
  size = 40,
  padding = 8
}) => {
  const imageSize = size - padding * 2
  const resolvedBgColor = TACHYONS_COLOR_MAP[backgroundColor] ?? backgroundColor
  return (
    <Box
      className={className}
      display="flex"
      alignItems="center"
      justifyContent="center"
      borderRadius={(theme) => theme.tokens.borderRadius.round}
      sx={{ blockSize: size, inlineSize: size, backgroundColor: resolvedBgColor }}
    >
      <img
        src={`/images/${iconName}.png`}
        srcSet={`/images/${iconName}-2x.png 2x`}
        alt=""
        height={imageSize}
        width={imageSize}
      />
    </Box>
  )
}

CircleImage.propTypes = {
  iconName: PropTypes.string.isRequired
}
export { CircleImage }
